// export const fillColors = [
// 	"#006BA2",
// 	"#DB444B",
// 	"#3EBCD2",
// 	"#379A8B",
// 	"#EBB434",
// 	"#B4BA39",
// 	"#9A607F",
// 	"#D1B07C",
// 	"#758D99",
// 	"#DB444B"
// ]; // https://design-system.economist.com/documents/CHARTstyleguide_20170505.pdf

// fintech new standard color
// export const fillColors = [
// 	"#3BAFDA",
// 	"#60A5FA",
// 	"#8BE0C4",
// 	"#6366F1",
// 	"#E9DB9B",
// 	"#E79CA8",
// 	"#7ED4E6",
// 	"#A3A8E5",
// 	"#F2E6C9",
// 	"#94A3B8"
// ]; // https://design-system.economist.com/documents/CHARTstyleguide_20170505.pdf

// export const fillColorsLight = [
// 	"#B3E5F1",
// 	"#CFE4FF",
// 	"#D6F7EB",
// 	"#C9CBFF",
// 	"#FAF3CD",
// 	"#FAD2D7",
// 	"#D4F4FB",
// 	"#E0E2FB",
// 	"#FBF7EA",
// 	"#D8DEE9"
// ];

// export const fillColorsDark = [
// 	"#228FB5",
// 	"#3A7EE0",
// 	"#49B995",
// 	"#3B3EC8",
// 	"#C8B867",
// 	"#C86E7C",
// 	"#4DA7BD",
// 	"#6D72C5",
// 	"#D6C797",
// 	"#475569"
// ];

// // fintech standard color
export const fillColors = [
	"#A7DDF1",
	"#6672B3",
	"#7FC7B8",
	"#5CA882",
	"#E9DB9B",
	"#C7C67A",
	"#E79CA8",
	"#C98FBF",
	"#B97A97",
	"#B79E93"
]; // https://design-system.economist.com/documents/CHARTstyleguide_20170505.pdf

export const fillColorsLight = [
	"#DFF3FB",
	"#DADDF2",
	"#D4EEE8",
	"#CFEADC",
	"#F6F1D2",
	"#F1F2CE",
	"#FBE4E6",
	"#F4E1EF",
	"#F0D9DD",
	"#EEE3DF"
];

export const fillColorsDark = [
	"#7FBFDC",
	"#505C97",
	"#5BAA99",
	"#4D8D6F",
	"#C1B25C",
	"#9A9B56",
	"#CF808B",
	"#A36898",
	"#92586E",
	"#8E7368"
];

// fintech alternative colors

// export const fillColors = [
// 	"#4F9DCC",
// 	"#5E6EC3",
// 	"#6BBCA8",
// 	"#9FD5C2",
// 	"#A6C8E6",
// 	"#B8B27D",
// 	"#E4A6B2",
// 	"#B39CB7",
// 	"#9E8C84",
// 	"#4A4A4A"
// ]; // https://design-system.economist.com/documents/CHARTstyleguide_20170505.pdf

// export const fillColorsLight = [
// 	"#B8DDF0",
// 	"#B9C2E9",
// 	"#BCE5D8",
// 	"#D8EEE5",
// 	"#DCE8F5",
// 	"#E3DFB5",
// 	"#F3D1D8",
// 	"#D9CBE0",
// 	"#CFC7C2",
// 	"#FFFFFF"
// ];

// export const fillColorsDark = [
// 	"#4F9DCC",
// 	"#5E6EC3",
// 	"#6BBCA8",
// 	"#9FD5C2",
// 	"#A6C8E6",
// 	"#B8B27D",
// 	"#E4A6B2",
// 	"#B39CB7",
// 	"#9E8C84",
// 	"#4A4A4A"
// ];

// export const fillColors = [
// 	"#4E79A7",
// 	"#F28E2B",
// 	"#59A14F",
// 	"#E15759",
// 	"#76B7B2",
// 	"#EDC948",
// 	"#B07AA1",
// 	"#FF9DA7",
// 	"#9C755F",
// 	"#BAB0AC"
// ];


// const fillColors = [
// 	colors.lightblue6,
// 	colors.teal4,
// 	colors.yellow4,
// 	colors.lightblue1,
// 	colors.lightblue3,
// 	colors.lightblue5,
// 	colors.lightblue6,
// 	colors.lightblue7,
// 	colors.lightblue9,
// ];